<table class="table table-bordered table-subfamilies">
    <thead>
        <tr>
            <th class="ta bg-th"  colspan="6">
                <div class="row">
                    <div>
                        Ingredientes
                        <span class="a-hover" (click)="addIngredient()">
                        <i *ngIf="addingIngredient === recipeId" class="fa fa-minus"></i>
                        <i *ngIf="addingIngredient !== recipeId" class="fa fa-plus"></i>
                    </span>
                    </div>
                </div>

                <div class="row" *ngIf="addingIngredient === recipeId">
					<div class="form-group">
						<label for="toTransfer" class="form-label">Ingrediente Nuevo</label>
						<div class="input-group input-group-sm">
							<label for="to" class="input-group-text"><i class="fa fa-box"></i></label>
							<app-input-autocomplete
								(getTitle)="$event.filterElement.title = $event.filterElement.code + ' - ' +$event.filterElement.name"
								[allBorderRadius]="false" 
                                [placeholder]="'Ingresa un producto a agregar a la receta'"
								[inputs]="productInput"
                                [filterElements]="filteredProducts"
                                [custom]="true"
								(inputMethod)="onInput($event)"
								(changeStatus)="onSelectProduct($event)">
								<ng-template #itemsTemplate let-filter>
									<div class="field">
										<span class="val-span">{{filter.name}}</span>
										<span class="field-span">
											<b>
												<i class="fa fa-barcode"></i>
											</b>
											{{filter.barCode}}
											<i class="fa fa-question" style="opacity: 0.8;" *ngIf="!filter.barCode"></i>
											<b style="margin-left: 1rem;">
												<i class="fa fa-key"></i>
											</b>
											{{filter.code}}
											<i class="fa fa-question" style="opacity: 0.8;" *ngIf="!filter.code"></i>
										</span>
									</div>
								</ng-template>
							</app-input-autocomplete>
						</div>
					</div>
                </div>
            </th>
        </tr>
        <tr>
            <th>Código</th>
            <th>Nombre</th>
            <th class="text-center">Cantidad</th>
            <th class="text-right">Costo (Unitario)</th>
            <th class="text-right">Costo (Total)</th>
            <th class="text-center">Acciones</th>
        </tr>
    </thead>
    <tbody>
        <ng-container *ngFor="let ingredient of ingredients">
            <tr>
                <td class="ta">{{ingredient.productDataIngredient.code}}</td>
                <td class="ta">{{ingredient.productDataIngredient.name}}</td>
                <td class="td-center" style="max-width: 85px;min-width: 85px;">
                    <div *ngIf="editingIngredient !== ingredient.id" >
                        <span (click)="startEditing(ingredient.id)" class="profit-ammount">
                                {{ingredient.quantity}}
                                <i class="fa fa-edit span-hover"></i>
                        </span>
                    </div>

                    <div *ngIf="editingIngredient === ingredient.id" class="input-group input-group-sm">
                        <input #newQty type="number" name="profit" [value]="ingredient.quantity"
                            style="text-align: center;"
                            id="profit" class="form-control" min="0" step="0.01"/>
                        <button class="btn btn-success"
                            [disabled]="loading[ingredient.id]"
                            (click)="saveQuantity(ingredient, newQty.value)">
                            <ng-container *ngIf="!loading[ingredient.id]">
                                <i class="fa fa-floppy-disk"></i>
                            </ng-container>
                            <ng-container *ngIf="loading[ingredient.id]">
                                <span
                                    class="spinner-border spinner-border-sm"
                                    aria-hidden="true"></span>
                                <span role="status"></span>
                            </ng-container>
                        </button>
                    </div>

                </td>
                <td class="text-right">
                    {{ productCosts[ingredient.id] | currency:'Q':'symbol':'1.2-2' }}
                </td>
                <td class="text-right">
                    {{ getIngredientTotalCost(ingredient) | currency:'Q':'symbol':'1.2-2' }}
                </td>
                <td class="flex-container-center">
                    <span class="a-hover text-danger" (click)="deleteIngredient(ingredient)">
                        <i class="fa fa-trash"></i>
                    </span>
                </td>
            </tr>
        </ng-container>
    </tbody>
    <tfoot>
        <tr>
            <td colspan="3" class="font-bold">TOTAL</td>
            <td></td>
            <td class="text-right font-bold">{{ totalcost | currency:'Q':'symbol':'1.2-2' }}</td>
            <td></td>
        </tr>
    </tfoot>
</table>
